// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".single-select-dropdown[data-v-47d07d70] {\n  /* Add your styling here */\n}\n", ""]);
// Exports
module.exports = exports;
